/**
 * @fileOverview Colours used in .js and .jsx files need to be standardized
 * using the values contained in this file.
 *
 * This is the color palette from [ant.design](https://ant.design/docs/spec/colors)
 *
 * PLEASE TO NOT ADD TO OR CHANGE VALUES IN THIS FILE WITHOUT SPEAKING TO THE
 * LEAD ON INTERFACE DESIGN.
 */

export const blue10 = "hsl(217,100%,20%)";
export const blue9 = "hsl(215,100%,28%)";
export const blue8 = "hsl(213,100%,35%)";
export const blue7 = "hsl(211,92%,44%)";
export const blue6 = "hsl(209,100%,55%)";
export const blue5 = "hsl(207,100%,62%)";
export const blue4 = "hsl(205,99%,71%)";
export const blue3 = "hsl(203,100%,79%)";
export const blue2 = "hsl(201,100%,86%)";
export const blue1 = "hsl(199,100%,95%)";
export const grey10 = "hsl(0,0%,0%)";
export const grey9 = "hsl(116,0%,15%)";
export const grey8 = "hsl(116,0%,35%)";
export const grey7 = "hsl(116,0%,55%)";
export const grey6 = "hsl(116,0%,75%)";
export const grey5 = "hsl(116,0%,85%)";
export const grey4 = "hsl(116,0%,91%)";
export const grey3 = "hsl(116,0%,96%)";
export const grey2 = "hsl(116,0%,98%)";
export const grey1 = "hsl(115,100%,100%)";
export const red10 = "hsl(349,99%,18%)";
export const red9 = "hsl(351,100%,26%)";
export const red8 = "hsl(353,93%,34%)";
export const red7 = "hsl(355,83%,44%)";
export const red6 = "hsl(357,91%,55%)";
export const red5 = "hsl(359,100%,65%)";
export const red4 = "hsl(1,100%,73%)";
export const red3 = "hsl(3,100%,81%)";
export const red2 = "hsl(5,100%,89%)";
export const red1 = "hsl(5,100%,97%)";
export const green10 = "hsl(108,100%,8%)";
export const green9 = "hsl(106,100%,16%)";
export const green8 = "hsl(104,94%,24%)";
export const green7 = "hsl(102,85%,33%)";
export const green6 = "hsl(100,77%,43%)";
export const green5 = "hsl(98,61%,53%)";
export const green4 = "hsl(96,65%,63%)";
export const green3 = "hsl(94,69%,74%)";
export const green2 = "hsl(92,78%,86%)";
export const green1 = "hsl(91,100%,97%)";
export const yellow10 = "hsl(44,100%,19%)";
export const yellow9 = "hsl(46,100%,26%)";
export const yellow8 = "hsl(48,100%,34%)";
export const yellow7 = "hsl(50,95%,43%)";
export const yellow6 = "hsl(52,96%,53%)";
export const yellow5 = "hsl(54,100%,62%)";
export const yellow4 = "hsl(56,99%,70%)";
export const yellow3 = "hsl(58,100%,78%)";
export const yellow2 = "hsl(60,100%,86%)";
export const yellow1 = "hsl(62,100%,95%)";
export const gold10 = "hsl(32,99%,19%)";
export const gold9 = "hsl(34,100%,27%)";
export const gold8 = "hsl(36,100%,34%)";
export const gold7 = "hsl(38,94%,43%)";
export const gold6 = "hsl(40,96%,53%)";
export const gold5 = "hsl(42,100%,62%)";
export const gold4 = "hsl(44,100%,70%)";
export const gold3 = "hsl(46,100%,78%)";
export const gold2 = "hsl(48,100%,86%)";
export const gold1 = "hsl(51,100%,95%)";

export const COLOR_BACKGROUND_LIGHTEST = grey1;
export const COLOR_BACKGROUND_LIGHT = grey4;
export const COLOR_BACKGROUND_DARK = grey8;
export const COLOR_BORDER_LIGHT = grey4;
